<template>
  <ReportTable
    v-loading="tableLoading"
    :type="type"
    :title="title"
    :fields="fields"
    :items="items"
    :pageTotal="pageTotal"
    :currentPage="currentPage"
    :rows="rows"
    :select-dropdown="selectDropdown"
    :path="path"
    :showHKSelect="true"
    @handleSearch="handleSearch"
    @handleHighestChange="handleHighestChange"
    @handleDateChange="handleDateChange"
    @handleOptionChange="handleOptionChange"
    @handleLocationChange="handleLocationChange"
  />
</template>
<script>
import ReportTable from './components/reportTable.vue'
import { getHighestDay } from '@/api/specialRecord'
export default {
  name: 'ReportVersion',
  components: {
    ReportTable
  },
  data() {
    return {
      tableLoading: false,
      type: 'highestsingleday',
      title: '22.6 最高單日票房 (by film)',
      currentPage: 1,
      selectDropdown: true,
      path: 'special-film-record',
      fields: [
        {
          key: 'name',
          label: 'film name',
          sortable: true
        },
        {
          key: 'origin',
          label: 'country',
          sortable: true
        },
        {
          key: 'date_release',
          label: 'date release',
          sortable: true
        },
        {
          key: 'date_off',
          label: 'date off',
          sortable: true
        },
        {
          key: 'single_day_highest_date',
          label: 'highest single date',
          sortable: true
        },
        {
          key: 'max_number_theatre_in_day',
          label: 'highest single theatres num',
          sortable: true
        },
        {
          key: 'max_number_screens_in_day',
          label: 'highest single screens num',
          sortable: true
        },

        {
          key: 'max_number_session_in_day',
          label: 'highest single session num',
          sortable: true
        },
        {
          key: 'single_day_highest',
          label: 'highest single b.o.',
          sortable: true
        },

        {
          key: 'highest_number_visitors',
          label: 'highest single adm.',
          sortable: true
        },
        {
          key: 'bo_cummulative',
          label: 'total b.o.',
          sortable: true
        },
        {
          key: 'visit_cummulative',
          label: 'total adm.',
          sortable: true
        }
      ],
      items: [],
      pageTotal: 10,
      perPage: 5,
      rows: 10,
      highestoption: '',
      startDate: '',
      endDate: new Date().toISOString().split('T')[0],
      option: '',
      location: ''
    }
  },
  methods: {
    handleLocationChange(val) {
      this.location = val
    },
    handleHighestChange(val) {
      this.highestoption = val
    },
    handleDateChange(from, to) {
      this.startDate = from
      this.endDate = to
    },
    handleOptionChange(val) {
      this.option = val
    },
    handleSearch() {
      this.currentPage = 1
      this.getReport()
    },
    getReport() {
      this.tableLoading = true
      let data = `date_start=${this.startDate}&date_end=${
        this.endDate
      }&area=${window.sessionStorage.getItem('area') || ''}&country=${
        this.option
      }`
      if (this.$route.query.data === 'by-day') {
        data += '&mode=day_date'
      }
      getHighestDay(data)
        .then((res) => {
          const arr = []
          this.items = arr
          res.data.forEach((el) => {
            let highlight = ''
            if (el.production && el.production.length > 0) {
              el.production.map((disEl) => {
                if (disEl.is_jv === 1) {
                  highlight = 'danger'
                }
              })
            }

            const obj = new Object()
            obj.name = el.film_master.name_chinese
            obj.origin = el.film_master.country
            obj.date_off =
              el.film_master.film[0].date_off === '0001-01-01'
                ? '上映中'
                : el.film_master.film[0].date_off
            obj.date_on = el.film_master.film[0].date_on
            // 22.6 / 22.6.1 的日期欄改用接口的 date_release（與 date_on 同一層）
            obj.date_release = el.film_master.film[0].date_release
            // 保持原始日期字串，交給 reportTable 的 date slot 統一輸出 MM-DD-YYYY
            obj.single_day_highest_date = el.highest_on_date
            obj.max_number_theatre_in_day = el.num_cinema
            obj.max_number_screens_in_day = el.num_screen
            obj.max_number_session_in_day = el.num_show
            obj.single_day_highest = el.highest_day_bo
            obj.highest_number_visitors = el.highest_day_ad
            obj.bo_cummulative = el.total_bo
            obj.visit_cummulative = el.total_ad
            obj._rowVariant = highlight
            arr.push(obj)
          })
          this.items = arr
          this.pageTotal = this.items.length
          this.tableLoading = false
        })
        .catch((error) => {
          this.tableLoading = false
        })
    }
  },
  mounted() {
    this.getReport()
  },
  created() {
    if (this.$route.query.data === 'by-day') {
      this.title = '22.6.1 單日最高票房 (by day)'
      this.fields = this.fields.map((field) => ({
        ...field,
        label: field.label.replace('highest single', 'single day')
      }))
    }
    const oneMonthAgoDate = new Date()
    oneMonthAgoDate.setMonth(oneMonthAgoDate.getMonth() - 1)
    this.startDate = oneMonthAgoDate.toISOString().slice(0, 10)
    this.endDate = this.$moment().format('YYYY-MM-DD')
  }
}
</script>
